module.exports = __webpack_public_path__ + "384a4e00265f5a990d1af1b81030d0b2.png";